module.exports = __webpack_public_path__ + "img/pega_todo.f4290b54.png";